export default __webpack_public_path__ + "static/client2-a159ebd1fc003e4592ecfbf1f7819a74.png";